import React, { useState, useEffect } from 'react';
import { Route, Navigate } from 'react-router-dom';

function PrivateRoute({ element }) {
  const token = localStorage.getItem('authToken'); // Прочитај го токенот од localStorage
  const [isTokenValid, setIsTokenValid] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (token) {
      // Validate the token only if there is one in localStorage
      validateToken(token).then((isValid) => {
        setIsTokenValid(isValid); // Update the state based on token validity
      });
    } else {
      // If no token is found, the token is invalid
      setIsTokenValid(false);
    }
  }, [token]);

  const validateToken = async (token) => {
    try {
      const response = await fetch(`${API_URL}/account/validate-token`, {  // Your API endpoint for token validation
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`, // Send token in Authorization header
          "Content-Type": "application/json",
        },
      });

      // If response is successful, the token is valid
      if (response.ok) {
        return true;
      } else {
        // If the response is not OK (401 or 403), the token is invalid
        return false;
      }
    } catch (error) {
      // Handle network or other errors
      console.error("Error validating token:", error);
      return false;
    }
  };


  if (isTokenValid === null) {
    return <div>Loading...</div>; // Or any loading indicator you prefer
  }

  // If the token is invalid, redirect to login
  if (!isTokenValid) {
    return <Navigate to="/" />;  // Redirect to the login page
  }

  // If the token is valid, render the admin panel component
  return element;
}

export default PrivateRoute
